import type { InstituteTypeDraftFields } from './instituteTypeRules';
import { strOrNull } from './caseRequestPayload';

export type InstituteApiPayloadFields = {
  is_corporation?: boolean;
  corporate_institute?: string | null;
  other_institute?: string | null;
};

export function buildInstituteApiPayload(draft: InstituteTypeDraftFields): InstituteApiPayloadFields {
  if (!draft.instituteType) return {};

  if (draft.instituteType === 'government') {
    return {
      is_corporation: false,
      corporate_institute: null,
      other_institute: null,
    };
  }

  return {
    is_corporation: true,
    corporate_institute: strOrNull(draft.corporateInstituteId),
    other_institute: strOrNull(draft.corporateInstituteOther),
  };
}

export function mapInstituteFromApiResponse(
  raw: {
    is_corporation?: boolean;
    isCorporation?: boolean;
    corporate_institute?: string;
    corporate_institute_id?: string | null;
    corporate_institute_name?: string | null;
    corporateInstitute?: string;
    corporateInstituteId?: string | null;
    corporateInstituteName?: string | null;
    /** Civil Advise API typo — kept for backward compatibility */
    cooperate_institute_id?: string | null;
    cooperate_institute_name?: string | null;
    other_institute?: string | null;
    otherInstitute?: string | null;
    other_institute_name?: string | null;
  },
  prev: InstituteTypeDraftFields,
): Partial<InstituteTypeDraftFields> {
  const isCorp = raw.is_corporation ?? raw.isCorporation;
  if (isCorp === true) {
    const corpId = (
      raw.corporate_institute_id ??
      raw.corporateInstituteId ??
      raw.cooperate_institute_id ??
      raw.corporate_institute ??
      raw.corporateInstitute ??
      ''
    ).trim();
    const corpName = (
      raw.corporate_institute_name ??
      raw.corporateInstituteName ??
      raw.cooperate_institute_name ??
      ''
    ).trim();
    const other = (
      raw.other_institute_name ??
      raw.other_institute ??
      raw.otherInstitute ??
      ''
    ).trim();
    return {
      instituteType: 'corporation',
      corporateInstituteId: corpId || prev.corporateInstituteId,
      corporateInstituteName: corpName || prev.corporateInstituteName,
      corporateInstituteOther: other || prev.corporateInstituteOther,
    };
  }
  if (isCorp === false) {
    return {
      instituteType: 'government',
      corporateInstituteId: '',
      corporateInstituteName: '',
      corporateInstituteOther: '',
      corporateInstituteContactName: '',
      corporateInstitutePrefix: '',
    };
  }
  return {};
}
